
const AvatarList = ({avatarList, handleSelectAvatar, selectedAvatar, origin}) => {

    return(
      <>
      <div className="menu__content-submenu">
            {
               avatarList?.map(avatar => (
                <div className={`menu_avatar-item ${avatar.avatar.name === selectedAvatar ? 'active' : ''} `} onClick={() => handleSelectAvatar(avatar.avatar)}>
                  <div className="avatar-photo">
                  {
                    avatar.avatar ?
                      <img className={`${origin}`} src={process.env.REACT_APP_FXAI_SERVER_URL + avatar.avatar.hyperlink.split("\\").join("/")} alt="" /> :
                      <img className={`${origin}`} src={`${process.env.PUBLIC_URL}/assets/placeholder.png`} alt="" />
                  }
                  <div className={`avatar-shape ${origin}`}></div>
                  </div>
                  
                  <p>{avatar.avatar?.name}</p>
                </div>
               ))
            }
            
            
          </div>
      </>
        
    )

}

export default AvatarList;